/*
 * @Author: bbqin
 * @Date: 2021-07-20 10:16:24
 * @LastEditTime: 2021-08-12 19:12:36
 * @LastEditors: bbqin
 * @Description: 啥功能呢
 * @FilePath: \Platform_Front\src\platform\base\Calculator\operate.js
 * 这锅我不背
 */
import Big from "big.js";
// 截断
// Big.RM = 0;

const PPP = 16;

export default function operate(numberOne, numberTwo, operation) {
    const one = Big(numberOne || "0");
    const two = Big(numberTwo || (operation === "÷" || operation === 'x' ? "1" : "0")); //If dividing or multiplying, then 1 maintains current value in cases of null
    if (operation === "+") {
        return one.plus(two).round(PPP).toString();
    }
    if (operation === "-") {
        return one.minus(two).round(PPP).toString();
    }
    if (operation === "x") {
        return one.times(two).round(PPP).toString();
    }
    if (operation === "+/-") {
        return (one.gte(0) ? Big('-' + (numberOne || "0")) : one.abs()).round(PPP).toString();
    }
    if (operation === "÷") {
        if (two === "0") {
            console.error("Divide by 0 error");
            return "0";
        } else {
            // 解决 1/3 不能还原为三的问题
            let result = one.div(two);
            let p12 = result.round(12).toString();
            // 12位时时整数
            if (p12.indexOf('.') === -1) {
                return p12;
            }
            return result.round(PPP).toString();
        }
    }
    
    if (operation === "sqrt") {
        return one.sqrt().round(PPP).toString();
    }
    
    if (operation === "round") {
        // x = 123.45
        // Math.round(x)                  // 123

        // y = new Big(x)
        // y.round()                      // '123'
        // y.round(2)                     // '123.45'
        // y.round(10)                    // '123.45'
        // y.round(1, Big.roundDown)      // '123.4'
        // y.round(1, Big.roundHalfUp)    // '123.5'
        // y.round(1, Big.roundHalfEven)  // '123.4'
        // y.round(1, Big.roundUp)        // '123.5'
        // y.round(-1, Big.roundDown)     // '120'
        // y.round(-2, Big.roundUp)       // '200'
        // y                              // '123.45'
        return one.round().toString();
    }
    throw Error(`Unknown operation '${operation}'`);
}
